import React, { useState, useEffect, useMemo } from "react";
import { Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./Despacho.component.scss";

const DespachoComponent = ({ sucursales = [], metodoDespacho }) => {
  const [envio, setEnvio] = useState(false);
  const [retiro, setRetiro] = useState(true);
  const [sucursalActual, setSucursalActual] = useState({});

  const handleChangeRetiro = () => {
    setEnvio(false);
    setRetiro(true);
  };

  const handleChangeEnvio = () => {
    setEnvio(true);
    setRetiro(false);
  };

  const estiloRetiro = () => {
    let estilo = `Despacho__Formas--Contenedor-Datos`;

    if (retiro) {
      estilo = `${estilo} Despacho__Formas--Contenedor-Datos-Actual`;
    }

    return estilo;
  };

  const estiloDespacho = () => {
    let estilo = `Despacho__Formas--Contenedor-Datos`;

    if (envio) {
      estilo = `${estilo} Despacho__Formas--Contenedor-Datos-Actual`;
    }

    return estilo;
  };

  const Sucursal = () => {
    return (
      <div className="Sucursal">
        <div className="Sucursal__Contenedor">
          <h5 className="Sucursal__Contenedor--Titulo">
            Seleccione sucursal de retiro
          </h5>
          <ul className="Sucursal__Contenedor--Lista">
            {sucursales.map((sucursal, index) => {
              const { datos } = sucursal;
              return (
                <li key={sucursal.id}>
                  <Form.Check
                    name="rbSucursal"
                    custom
                    type="radio"
                    id={sucursal.id}
                    label={datos.Descripcion}
                    checked={sucursal.id === sucursalActual.id ? true : false}
                    onChange={() => {
                      setSucursalActual(sucursal);
                    }}
                  />
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    );
  };

  const Retiro = () => {
    return (
      <div className="Retiro">
        <div className="Retiro__Contenedor">
          <h5>
            Si selecciona el metodo de despacho por retiro, debera buscar el
            pedido en la sucursal indicada
          </h5>
        </div>
      </div>
    );
  };

  const Envio = () => {
    return (
      <div className="Envio">
        <div className="Envio__Contenedor">
          <h5>
            Si selecciona el metodo de despacho por retiro, debera buscar el
            pedido en la sucursal indicada
          </h5>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (sucursales.length > 0 && retiro) {
      const sucursal = sucursales[0] || {};
      setSucursalActual(sucursal);
    }
  }, [sucursales]);

  useEffect(() => {
    if (retiro) {
      metodoDespacho("retiro", sucursalActual);
      return;
    }

    if (envio) {
      metodoDespacho("envio", {});
      return;
    }
  }, [sucursalActual, envio, retiro]);

  return (
    <>
      <Sucursal />
      <div className="Despacho">
        <div className="Despacho__Formas">
          <div className="Despacho__Formas--Contenedor">
            <div
              className="Despacho__Formas--Contenedor-Datos"
              className={estiloRetiro()}
              onClick={handleChangeRetiro}
            >
              <FontAwesomeIcon icon={["fas", "store"]} size="lg" />
              <h5>Retiro</h5>
            </div>
          </div>
          <div className="Despacho__Formas--Contenedor">
            <div
              className="Despacho__Formas--Contenedor-Datos"
              className={estiloDespacho()}
              onClick={handleChangeEnvio}
            >
              <FontAwesomeIcon icon={["fas", "bicycle"]} size="lg" />
              <h5>Envio</h5>
            </div>
          </div>
        </div>
        <div className="Despacho__Datos">
          {retiro ? <Retiro /> : null}
          {envio ? <Envio /> : null}
        </div>
      </div>
    </>
  );
};

export default DespachoComponent;
